export const runningOnProduction = () => window.location.hostname.includes('.getaccept.com');
